import stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { TrashIcon } from '@shared/assets/icons';
import { IconButton } from '@shared/ui/icon-button';
import InputClearable from '@shared/ui/input-clearable';
import { styles } from '../styles';

export interface ExtraGuestRowItem {
  id: number;
  lastName: string;
  firstName: string;
  patronymic: string;
}

type FieldKey = keyof Omit<ExtraGuestRowItem, 'id'>;

interface ExtraGuestRowProps {
  item: ExtraGuestRowItem;
  title: string;
  onUpdate: (id: number, field: FieldKey, value: string) => void;
  onRemove: (id: number) => void;
}

export const ExtraGuestRow: FC<ExtraGuestRowProps> = ({ item, title, onUpdate, onRemove }) => (
  <div {...stylex.props(styles.adultCont)}>
    <div {...stylex.props(styles.adultCont1)}>
      <div {...stylex.props(styles.adultTitle)}>
        <div {...stylex.props(styles.adultTitleText)}>{title}</div>
      </div>
      <div {...stylex.props(styles.adultInputContainer)}>
        <div {...stylex.props(styles.adultInputContent)}>
          <InputClearable
            status="default"
            size="small"
            settings={{ width: '252px' }}
            labelText="Фамилия"
            placeholder="Укажите фамилию"
            value={item.lastName}
            changeFunction={(v: string) => onUpdate(item.id, 'lastName', v)}
            clearHandler={() => onUpdate(item.id, 'lastName', '')}
          />
          <InputClearable
            status="default"
            size="small"
            settings={{ width: '252px' }}
            labelText="Имя"
            placeholder="Укажите имя"
            value={item.firstName}
            changeFunction={(v: string) => onUpdate(item.id, 'firstName', v)}
            clearHandler={() => onUpdate(item.id, 'firstName', '')}
          />
          <InputClearable
            status="default"
            size="small"
            settings={{ width: '252px' }}
            labelText="Отчество"
            placeholder="Укажите отчество"
            value={item.patronymic}
            changeFunction={(v: string) => onUpdate(item.id, 'patronymic', v)}
            clearHandler={() => onUpdate(item.id, 'patronymic', '')}
          />
        </div>
        <div {...stylex.props(styles.adultInputContentCard)}>
          <div {...stylex.props(styles.iconContainer)}>
            <IconButton icon={<TrashIcon color="currentColor" />} onClick={() => onRemove(item.id)} />
          </div>
        </div>
      </div>
    </div>
  </div>
);
